import { useFlags } from 'launchdarkly-react-client-sdk';

export default function useFeatureFlags() {
  const featureFlags = useFlags();

  const overridesString = localStorage.getItem('featureFlagOverrides');

  if (overridesString) {
    const overrides = JSON.parse(overridesString);

    const result = { ...featureFlags, ...overrides };

    return result;
  }

  return featureFlags;
}
